import { get, isEmpty, map } from 'lodash';

import { formatDate } from 'utils/date';

export const getMeetingLabel = (meeting) => {
  const meetingTopic = get(meeting, 'topic');

  const formattedMeetingSchedule = formatDate({
    date: get(meeting, 'scheduled_for'),
    format: 'MM/DD/YYYY'
  });
  if (isEmpty(meetingTopic)) {
    return formattedMeetingSchedule;
  }
  return `${formattedMeetingSchedule} - ${meetingTopic}`;
};

export const buildMeetingsOptions = (meetings) =>
  map(meetings, (meeting) => {
    return {
      value: meeting.invitation_identifier,
      label: getMeetingLabel(meeting)
    };
  });

export const getMeetingTitle = (meeting) => {
  const topic = get(meeting, 'topic', '');
  const scheduledFor = get(meeting, 'scheduled_for');

  const scheduleDateFormatted = formatDate({ date: scheduledFor });

  return isEmpty(topic)
    ? `Meeting date: ${scheduleDateFormatted}`
    : `${topic} - ${scheduleDateFormatted}`;
};
